import type { ApiReferenceTranslations } from '@scalar/types/api-reference'

export const ru = {
  common: {
    streamItem: 'Элемент потока',
    description: 'Описание',
    httpMethod: 'HTTP-метод',
    path: 'Путь',
    copyDefault: 'Скопировать значение по умолчанию',
    copyExample: 'Скопировать пример значения',
  },
  search: {
    label: 'Поиск',
    inputLabel: 'Введите поисковый запрос',
    open: 'Открыть поиск',
    placeholder: 'Поиск...',
    clear: 'Очистить поиск',
    noResults: 'Результаты не найдены',
    keyboardShortcut: 'Сочетание клавиш:',
    command: 'Command',
    control: 'Control',
    results: 'Результаты поиска по документации',
    navigate: 'Навигация',
    select: 'Выбрать',
    instructions:
      'Нажмите стрелку вверх или вниз для навигации, Enter для выбора, вводите текст для фильтрации результатов',
    entryHeading: 'Заголовок',
    entryOperation: 'Операция',
    entryTag: 'Тег',
    entryTagGroup: 'Группа тегов',
    entryWebhook: 'Вебхук',
  },
  navigation: {
    introduction: 'Введение',
    closeGroup: 'Закрыть группу',
    closeMenu: 'Закрыть меню',
    openGroup: 'Открыть группу',
    openMenu: 'Открыть меню',
    operations: 'Операции',
    endpoints: 'Эндпоинты {name}',
    showAllEndpoints: 'Показать все эндпоинты {name}',
    sidebarFor: 'Боковая панель для {name}',
    mainContent: 'Документация API для {name}',
    collapsed: 'Свернуто',
    webhooks: 'Вебхуки',
    channels: 'Каналы',
  },
  server: {
    label: 'Сервер',
    select: 'Выберите сервер',
  },
  info: {
    termsOfService: 'Условия использования',
  },
  asyncapi: {
    servers: 'Серверы',
    protocols: 'Протоколы',
  },
  clientLibraries: {
    heading: 'Клиентские библиотеки',
    more: 'Ещё',
    selectAll: 'Выбрать из всех клиентов',
    searchLabel: 'Поиск клиентов',
    changeClient: 'Изменить язык примера кода',
  },
  operation: {
    codeSampleUnavailable: 'Для этого примера нет доступного образца кода.',
    codeSample: 'Пример кода',
    body: 'Тело',
    cookies: 'Cookie',
    headers: 'Заголовки',
    pathParameters: 'Параметры пути',
    queryParameters: 'Query-параметры',
    requestBody: 'Тело запроса',
    responses: 'Ответы',
    testRequest: 'Проверить запрос',
    webhook: 'Вебхук',
    selectedContentType: 'Выбранный тип содержимого',
    callbacks: 'Обратные вызовы',
  },
  response: {
    xmlGenerationLimit:
      'Пример XML превышает ограничение генерации. Укажите сериализованный пример XML, чтобы отобразить содержимое полностью.',
    xmlGenerationFailed: 'Не удалось создать пример XML: {message}',
    exampleResponses: 'Примеры ответов',
    noBody: 'Нет тела',
    showSchema: 'Показать схему',
    status: 'Статус',
  },
  schema: {
    noAllowedValues: 'Ни одно значение не удовлетворяет этому ограничению enum.',
    example: 'Пример',
    examples: 'Примеры',
    default: 'Значение по умолчанию',
    schema: 'Схема',
    emptyObject: 'Пустой объект',
    showAdditionalProperties: 'Показать дополнительные свойства',
    forName: 'для {name}',
    showSchemaDetails: 'Показать детали схемы',
    oneOf: 'Один из',
    anyOf: 'Любой из',
    allOf: 'Все из',
    not: 'Не',
    unknownType: 'неизвестный тип',
    propertyCount: 'Свойства: {count}',
    headerCount: 'Заголовки: {count}',
    recursiveReference: 'Рекурсивная ссылка на {name}',
    recursive: 'рекурсивно',
    additionalProperties: 'дополнительные свойства',
    const: 'константа',
    deprecated: 'устарело',
    discriminator: 'Дискриминатор',
    enum: 'enum',
    format: 'Формат',
    greaterThan: 'больше чем',
    keys: 'ключи',
    lessThan: 'меньше чем',
    max: 'макс.',
    min: 'мин.',
    maxLength: 'макс. длина',
    minLength: 'мин. длина',
    multipleOf: 'кратно',
    nullable: 'может быть null',
    propertyNames: 'имена свойств',
    pattern: 'Шаблон',
    copyPattern: 'Скопировать шаблон',
    readOnly: 'только чтение',
    required: 'обязательно',
    hideValues: 'Скрыть значения',
    showAllValues: 'Показать все значения',
    type: 'Тип',
    unique: 'уникально',
    values: 'значения',
    writeOnly: 'только запись',
  },
  download: {
    openapi: 'Скачать OpenAPI-документ',
    asyncapi: 'Скачать AsyncAPI-документ',
    asFormat: '{label} в формате {format}',
  },
  models: {
    label: 'Модели',
  },
  actions: {
    copyAsMarkdown: 'Копировать как Markdown',
    copied: 'Скопировано',
    copyMarkdownFailed: 'Не удалось скопировать Markdown',

    copyLink: 'Скопировать ссылку',
    copyLinkTo: 'Скопировать ссылку на {name}',
    copyToClipboard: 'Скопировать ссылку в буфер обмена',
    copyEndpointUrl: 'Скопировать URL endpoint-а',
    showMore: 'Показать ещё',
  },
  agent: {
    askAi: 'Спросить AI',
    askAiAgent: 'Спросить AI-агента',
    close: 'Закрыть клиент',
  },
  mcp: {
    generate: 'Создать MCP',
    connect: 'Подключить MCP',
  },
  developerTools: {
    title: 'Инструменты разработчика',
    configure: 'Настроить',
    share: 'Поделиться',
    deploy: 'Опубликовать',
    scalarConfiguration: 'Конфигурация Scalar',
    theme: 'Тема',
    layout: 'Макет',
    layoutOptions: 'Параметры макета',
    intro:
      'Инструменты разработчика позволяют настроить внешний вид и поведение документации. Также можно поделиться документацией через Scalar Registry.',
    disableToolbarBefore: 'Чтобы отключить панель, установите',
    disableToolbarAfter: 'в конфигурации.',
    localhostOnly: 'Инструменты разработчика отображаются только при запуске на localhost.',
    layoutModern: 'Современный',
    layoutClassic: 'Классический',
    showSidebar: 'Показать боковую панель',
    defaultOpenFirstTag: 'Открывать первый тег по умолчанию',
    defaultOpenAllTags: 'Открывать все теги по умолчанию',
    expandAll: 'Развернуть все {label}',
    expandAllResponses: 'Развернуть все ответы',
    hideClientButton: 'Скрыть кнопку клиента',
    hideDarkModeToggle: 'Скрыть переключатель тёмной темы',
    hideModels: 'Скрыть {label}',
    hideSearch: 'Скрыть поиск',
    showOperationId: 'Показать ID операции',
    hideTestRequestButton: 'Скрыть кнопку тестового запроса',
    scalarDocs: 'Scalar Docs',
    deployDescription:
      'Опубликуйте документацию на Scalar — современной платформе документации для вашего API и не только.',
    shareTitle: 'Поделиться API Reference',
    shareDescription:
      'Загрузите документ OpenAPI, чтобы поделиться API Reference с другими. Так же просто, как нажать кнопку.',
    uploadDocument: 'Загрузить документ',
    temporaryLinkExpiration: 'Документ будет автоматически удалён через 7 дней.',
    deployOnScalar: 'Опубликовать на Scalar',
    deployFree: 'Опубликуйте документацию бесплатно.',
    additionalFeaturesMightRequire: 'Для дополнительных возможностей может потребоваться',
    generate: 'Создать',
    passwordProtection: 'Защита паролем',
    customDomains: 'Пользовательские домены',
    freeFormContent: 'Произвольный контент',
    cdnInfrastructure: 'CDN-инфраструктура',
    pullFromGitHub: 'Загрузка из GitHub',
    markdownMdx: 'Markdown/MDX',
    spectralLinting: 'Линтинг Spectral',
    jsonSchemaHosting: 'Хостинг JSON Schema',
    askAi: 'Спросить AI',
    mcpServers: 'MCP-серверы',
    unableToExportDocument: 'Не удалось экспортировать активный документ',
    unknownError: 'Произошла неизвестная ошибка',
  },
  gettingStarted: {
    swaggerEditor: 'Swagger Editor',
    description:
      'Добро пожаловать в Scalar API References + Swagger Editor — бесплатный инструмент с открытым исходным кодом, который принимает файл Swagger/OAS и создаёт красивые API Reference.',
    showExample: 'Показать пример',
    uploadFile: 'Загрузить файл',
    integrations: 'ИНТЕГРАЦИИ',
    theming: 'ТЕМЫ',
    features: 'Возможности',
    customize: 'Настройка',
    customizeDescription: 'Используйте свою типографику и цветовые палитры или наши темы!',
    testing: 'Тестирование',
    testingDescription: 'Глубоко интегрированный REST API Client (тоже бесплатный и с открытым исходным кодом)',
    search: 'Поиск',
    searchDescription: 'Полностью интегрированный поиск (с использованием fuse.js)',
    hosting: 'Хостинг',
    hostingDescription: 'Бесплатный хостинг на поддомене https://apidocumentation.com',
    openApiSwagger: 'OpenAPI и Swagger',
    openApiSwaggerDescription: 'Поддержка OpenAPI 3.1, OpenAPI 3.0 и Swagger 2.0',
    codeSamples: 'Примеры кода',
    codeSamplesDescription: 'Примеры кода для демонстрации вашего API на самых популярных языках',
  },
  footer: {
    poweredByScalar: 'Работает на Scalar',
  },
  authentication: {
    detailsRequired: 'Требуется аутентификация',
    detailsOptional: 'Аутентификация необязательна',
    apiKey: 'Ключ API',
    mutualTLS: 'Взаимная аутентификация TLS',
    apiKeyCookie: 'Передайте ключ API в cookie «{name}».',
    apiKeyHeader: 'Передайте ключ API в заголовке «{name}».',
    apiKeyQuery: 'Передайте ключ API в параметре запроса «{name}».',
    title: 'Аутентификация',
    accepts: 'Принимает',
    allOf: 'все из:',
    authentication: 'аутентификация',
    optional: 'Аутентификация необязательна',
    oneOf: 'одно из:',
    required: 'Требуется аутентификация',
    requires: 'Требуется',
    scopes: 'Области OAuth',
  },
} satisfies ApiReferenceTranslations
